import {LISTING,ADD, BY_ID } from './type';

const initalState = {
    list: [],
    addDetails:[],
    byIdDetails:[]
};

const HelperDetails = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case LISTING:
            return {
                ...state,
                list: payload,
            };
        case ADD:
            return {
                ...state,
                addDetails: payload,
            };
        case BY_ID:
            return {
                ...state,
                byIdDetails: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default HelperDetails;
